import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Importing pages/components
import Hero from './pages/Hero';
import About from './pages/About';
import Skills from './pages/Skills';
import Education from './pages/Education';
import Experience from './pages/Experience';
import Service from './pages/Service';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Header from './components/Header';
import Testimonials from './pages/Testimonials';
import Footer from './components/Footer';

// Define themes
const themes = [
  // { name: 'Light', primary: '#1D63FF', secondary: '#00A4FF', background: '#F5F7FA', text: '#333333' },
  { name: 'Nature', primary: '#4CAF50', secondary: '#8BC34A', background: '#F1F8E9', text: '#333333' },
  { name: 'Dark', primary: '#BB86FC', secondary: '#03DAC6', background: '#121212', text: '#FFFFFF' }
];

function App() {
  const [currentTheme, setCurrentTheme] = useState(themes[0]);

  // Function to toggle theme
  const toggleTheme = () => {
    const currentIndex = themes.findIndex(theme => theme.name === currentTheme.name);
    const nextIndex = (currentIndex + 1) % themes.length;
    setCurrentTheme(themes[nextIndex]);
  };

  return (
    <div style={{ 
      background: currentTheme.background, 
      color: currentTheme.text,
      minHeight: '100vh'
    }}>
      <Header currentTheme={currentTheme} toggleTheme={toggleTheme} />
      <Hero currentTheme={currentTheme} />
      <About currentTheme={currentTheme} />
      <Skills currentTheme={currentTheme} />
      <Education currentTheme={currentTheme} />
      <Experience currentTheme={currentTheme} />
      <Service currentTheme={currentTheme} />
      <Projects currentTheme={currentTheme} />
      <Blog currentTheme={currentTheme} />
      <Testimonials currentTheme={currentTheme} />
      <Contact currentTheme={currentTheme} />
      <Footer currentTheme={currentTheme} />
    </div>
  );
}

export default App;